import React from 'react';
import { Plus } from 'lucide-react';

interface AddPillProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export const AddPill: React.FC<AddPillProps> = ({ label, onClick, disabled }) => (
  <button
    type="button"
    className="pgte-add-pill"
    onClick={onClick}
    disabled={disabled}
    title={label}
    aria-label={label}
  >
    <span className="pgte-add-icon">
      <Plus size={14} />
    </span>
    <span className="pgte-add-label">{label}</span>
  </button>
);
